import React from 'react';
import GeneralIcon from '../assets';

/**
 * SearchBar Component
 * Reusable purple search bar with icon
 * 
 * @param {string} value - Current search value
 * @param {function} onChange - Callback when value changes
 * @param {string} placeholder - Placeholder text (default: "Buscar")
 * @param {string} className - Additional CSS classes
 */
export default function SearchBar({ 
  value, 
  onChange, 
  placeholder = "Buscar",
  className = "" 
}) {
  return (
    <div className={`relative ${className}`}>
      <GeneralIcon
        iconName="search"
        className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-purple-200"
      />
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full pl-10 pr-4 py-3 rounded-lg bg-purple-600 text-white placeholder-purple-200 focus:outline-none focus:ring-2 focus:ring-purple-700"
      />
    </div>
  );
}
